import React from "react";
import Form from "../common/form";

export default class SignUpForm extends Form {
  render() {
    this.loggingIn = false;
    const { validateList, handleCompleteSignUpSubmit, handleDataUpdate } =
      this.props;
    const [
      validateCompleteSignUpFormUpper,
      validateCompleteSignUpFormSpecialChar,
      validateCompleteSignUpFormNumber,
      validateCompleteSignUpFormLower,
      validateCompleteSignUpFormLength,
      validateCompleteSignUpFormMatch,
    ] = validateList;

    return (
      <div className="content bg-img">
        <div className="center">
          <div className="row justify-content-md-center">
            <form
              onSubmit={(e) => {
                handleCompleteSignUpSubmit(e);
                this.loggingIn = true;
              }}
              className="form-size col col-lg-5"
            >
              <h1 style={{ color: "white", textAlign: "left" }}>
                Change Password
              </h1>
              {this.renderInput(
                "newPassword",
                "Password",
                "password",
                "new-password",
                false,
                "",
                handleDataUpdate
              )}
              {this.renderInput(
                "confirmNewPassword",
                "Confirm Password",
                "password",
                "new-password",
                false,
                "",
                handleDataUpdate
              )}
              <button
                style={{ width: "100%" }}
                type={"submit"}
                className={
                  validateCompleteSignUpFormLength() &&
                  validateCompleteSignUpFormNumber() &&
                  validateCompleteSignUpFormSpecialChar() &&
                  validateCompleteSignUpFormUpper() &&
                  validateCompleteSignUpFormLower() &&
                  validateCompleteSignUpFormMatch()
                    ? "btn btn-primary mt-3"
                    : "btn btn-secondary mt-3"
                }
                disabled={
                  validateCompleteSignUpFormLength() &&
                  validateCompleteSignUpFormNumber() &&
                  validateCompleteSignUpFormSpecialChar() &&
                  validateCompleteSignUpFormUpper() &&
                  validateCompleteSignUpFormLower() &&
                  validateCompleteSignUpFormMatch()
                    ? false
                    : true
                }
              >
                login
                {this.loggingIn && (
                  <div
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                  >
                    <span className="sr-only"></span>
                  </div>
                )}
              </button>
              <div style={{ color: "white", textAlign: "left" }}>
                <h4 style={{ marginTop: "10px" }}>Password Requirements:</h4>
                <div>
                  <span
                    className={
                      validateCompleteSignUpFormLength()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></span>{" "}
                  Requires at least a length of 8 characters
                </div>
                <div>
                  <span
                    className={
                      validateCompleteSignUpFormNumber()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></span>{" "}
                  Requires at least a number
                </div>
                <div>
                  <span
                    className={
                      validateCompleteSignUpFormLower()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></span>{" "}
                  Requires at least a lower case character
                </div>
                <div>
                  <span
                    className={
                      validateCompleteSignUpFormUpper()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></span>{" "}
                  Requires at least an UPPER case character
                </div>
                <div>
                  <span
                    className={
                      validateCompleteSignUpFormSpecialChar()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></span>{" "}
                  Requires at least a special character
                </div>
                <div>
                  <div
                    className={
                      validateCompleteSignUpFormMatch()
                        ? "dot-success"
                        : "dot-required"
                    }
                  ></div>{" "}
                  Passwords match
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
